var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "%23FF156D",
    stroke: "%23FF156D",
    strokeWidth: 15,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "%23FF156D",
    stroke: "%23FF156D",
    strokeWidth: 15,
    opacity: 0.8,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.05
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "%23FF156D",
    stroke: "%23FF156D",
    strokeWidth: 15,
    opacity: 0.6,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.1
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "%23FF156D",
    stroke: "%23FF156D",
    strokeWidth: 15,
    opacity: 0.4,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.15
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "%23FF156D",
    stroke: "%23FF156D",
    strokeWidth: 15,
    opacity: 0.2,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.e672f62fb006b6d704dafd0d7abc5add.svg";
export { ForwardRef as ReactComponent };